import store from 'redux/store';
import i18n from 'services/i18n';
import { DIGITAL_WALLET_PROVIDERS_FRIENDLY_NAME } from 'consts';

export const getPaymentErrorPrefix = ({ isCard, digitalWalletProvider, isDefault }) => {
  const {
    checkoutPage: { data: checkoutPageData }
  } = store.getState().checkout;

  let openingSentence;

  if (isCard) {
    openingSentence = digitalWalletProvider
      ? `${i18n.t('digital_wallet_providers.submission_error', {
          provider: DIGITAL_WALLET_PROVIDERS_FRIENDLY_NAME[digitalWalletProvider]
        })}`
      : `${i18n.t('createPaymentErrors.something_went_wrong')} ${i18n.t(
          'createPaymentErrors.different_pm_card'
        )}`;
    return openingSentence;
  }

  const onlyOnePMType =
    checkoutPageData?.payment_method_types?.length === 1 &&
    checkoutPageData?.payment_method_types[0]?.types?.length === 1;

  openingSentence = `${i18n.t('createPaymentErrors.something_went_wrong_please')} ${
    onlyOnePMType || isDefault ? '' : i18n.t('createPaymentErrors.different_pm')
  } ${i18n.t('try_again_later')}.`;
  return openingSentence;
};

export const getPayoutErrorPrefix = () => {
  const {
    payoutMethodTypesList: { data: payoutMethodTypes }
  } = store.getState().beneficiaryTokenization;

  const onlyOnePayoutMethodType = payoutMethodTypes.length === 1;

  const openingSentence = onlyOnePayoutMethodType
    ? `${i18n.t('createPaymentErrors.something_went_wrong_please')} ${i18n.t(
        'try_again_later'
      )}.`
    : `${i18n.t('beneficiaryErrors.different_pm')}`;

  return openingSentence;
};
